<template>
    <vue-qrcode
        :value="code"
        class="qr-code"
        :options="{
            margin: 0
        }">
    </vue-qrcode>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
    name : "QRImage",

    components: {
        VueQrcode
    },

    props: {
        code: {
            type: String
        }
    }
};
</script>

<style lang="scss" scoped>
    .qr-code {
        width : 7rem !important;
        height : 7rem !important;
    }
</style>